
/* eslint-disable no-undef */
export default window[CONSTANTS.coreName]

const Config = window[CONSTANTS.coreName].Config
const Status = window[CONSTANTS.coreName].Status
const Tasks = window[CONSTANTS.coreName].Tasks
const Events = window[CONSTANTS.coreName].Events
const Lazyloading = window[CONSTANTS.coreName].Lazyloading
const Visibility = window[CONSTANTS.coreName].Visibility

export { Config, Status, Tasks, Events, Lazyloading, Visibility }
